import { QuestionFormData } from '../types';

export interface SectionNumbering {
  number: number;
  sectionStart: boolean;
}

/**
 * Generate section-aware numbering for questions
 * Numbers reset for each new section
 * @param questions Array of question form data
 * @returns Array of numbering info for each question
 */
export const generateSectionNumbering = (
  questions: QuestionFormData[],
): SectionNumbering[] => {
  const numbering: SectionNumbering[] = [];
  let currentSection = '';
  let sectionNumber = 0;

  for (const question of questions) {
    const isNewSection = question.section !== currentSection;

    if (isNewSection) {
      currentSection = question.section;
      sectionNumber = 1;
    } else {
      sectionNumber++;
    }

    numbering.push({
      number: sectionNumber,
      sectionStart: isNewSection,
    });
  }

  return numbering;
};
